
export enum PillTheme {
    Default = 'default',
    Success = 'success',
    Failure = 'failure',
    Warning = 'warning',
    DarkGray = 'dark-gray',
}
export enum PillSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}